var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vx-card',[_c('vs-row',{staticClass:"mb-4",attrs:{"vs-justify":"center"}},[_c('h3',[_vm._v("Summary")])]),_vm._l((_vm.step.questions),function(question){return _c('Question',{key:question.id,attrs:{"question":question,"isEditable":_vm.meetingInstance.isEditable}})})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }